var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.href)?_c('button',{staticClass:"def-button-primary btn btn-std",attrs:{"type":_vm.type}},[_vm._t("default")],2):_c('a',{staticClass:"def-button-primary btn btn-std",attrs:{"href":_vm.href}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }